import Grid from '@mui/material/Grid';
import LongevityText from './LongevityText';
import LongevityCard from '../SectionGenetics/Longevity/LongevityCard';
//import CancerButtonGroup from './CancerButtonGroup';
import SectionStructure from '../../../../components/Section/SectionStructure';


export default function SectionLongevity() {
    
    return (

    <SectionStructure
    
        sectiontext=    { <LongevityText /> }

        sectioncards=  {<>

                    <Grid container sx={{display:'flex', justifyContent: 'center', alignItems: 'flex-start'}}>
                    
                            <Grid size={6}>   
                                <Grid container spacing={4} direction="column" sx={{ }}>    
                                    <Grid > <LongevityCard />   </Grid>
                                </Grid>
                            </Grid>

                            <Grid size={6}>  
                                <Grid container spacing={4} direction="column" sx={{ }}>
                                </Grid>     
                            </Grid>
                </Grid>  

        </>}
    />
)
}